import { format } from 'date-fns';
import { parseDateString } from '~/utils/DateUtils';

/**
 * Formats a calendar-date string (`YYYY-MM-DD`) as `MMM dd, yyyy`. Parses it as
 * a calendar date via `parseDateString`, NOT via `new Date(str)` — the latter
 * reads it as UTC midnight and can render a day off depending on the viewer's
 * timezone.
 */
export const formatBidCalendarDate = (value: string): string =>
  format(parseDateString(value), 'MMM dd, yyyy');
